export enum Language {
  EN = 'en',
  EN_US = 'en-us',
  UA = 'uk',
  TR = 'tr',
  HI = 'hi',
  ES = 'es',
  RU = 'ru',
  BR = 'pt',
  FR = 'fr',
  DE = 'de',
  FI = 'fi',
  PT_BR = 'pt-br',
  SQ = 'sq',
  HY = 'hy',
  ZH = 'zh',
  ZH_CN = 'zh-cn',
  ZH_TW = 'zh-tw',
  KA = 'ka',
  JA = 'ja',
  KK = 'kk',
  ES_LA = 'es-la',
  FA = 'fa',
  SR_LATN = 'sr-latn',
  SW = 'sw',
  ES_MX = 'es-mx',
  CS = 'cs',
  DA = 'da',
  EL = 'el',
  KO = 'ko',
  BG = 'bg',
  HR = 'hr',
  NL = 'nl',
  HU = 'hu',
  IT = 'it',
  NO = 'no',
  PL = 'pl',
  RO = 'ro',
  SR = 'sr',
  SK = 'sk',
  SL = 'sl',
  SV = 'sv',
  UZ = 'uz',
  AR = 'ar',
}
